<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  :append-to-body=true
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span  class="title" >{{title}}</span>
  </span>
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
      <el-form label-position="top" label-width="100px" :rules="rules" ref="creditNoteForm" :model="creditNote">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('credit_notes.customer')" prop="customer">
              <el-select
                v-model="creditNote.fk_customer_id"
                filterable
                remote
                reserve-keyword
                clearable
                :placeholder="$t('common.select.placeholder')"
                :remote-method="fetchSearchedCustomers"
                :loading="customersLoading"
                @change="selectCustomer">
                <el-option
                  v-for="customer in searchedCustomers"
                  :key="customer.id"
                  :label="customerName(customer)"
                  :value="customer.id">
                  <CustomerSelectItem :customer="customer"></CustomerSelectItem>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('credit_notes.creditNoteNumber')">
              <el-input :value="creditNote.cr_number" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('credit_notes.billingTo')" prop="fk_billing_contact_id" >
              <ContactPicker :disabled="creditNote.fk_customer_id==null" :contacts="contacts" :value="creditNote.fk_billing_contact_id" @selected="setSelectedContact" ></ContactPicker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('credit_notes.date')" prop="date">
              <el-date-picker v-model="creditNote.date" type="date" :placeholder="$t('common.selectDateInstruction')"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="creditNote.fk_customer_id!=null">
            <DefaultAddressCard :address="creditNote.billing_address"  :adresseTypeName="billingAddressName"></DefaultAddressCard>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('credit_notes.reference')">
              <el-input v-model="creditNote.reference"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider/>
        <h3>{{$t('credit_notes.details')}}</h3>
        <el-row :gutter="20">
          <el-form-item :label="$t('credit_notes.reference')" >
            <el-radio-group v-model="creditNote.type" @change="selectCreditType" :disabled="creditNote.fk_customer_id==null">
              <el-radio-button label="PRODUCTS" :disabled="fixedType && creditNote.type=='NET'">{{$t('credit_notes.creditNoteOnProducts')}}</el-radio-button>
              <el-radio-button label="NET" :disabled="fixedType && creditNote.type=='PRODUCTS'">{{$t('credit_notes.netCredit')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <div v-if="creditNote.type=='NET'">
          <el-table :data="creditNote.netLine" style="width: 100%" :border="true" v-loading="itemsLoading" :row-style="tableRowStyleFct" :cell-style="tableCellStyleFct">
            <el-table-column :label="$t('credit_notes.type')">
              <template slot-scope="scope">
                <el-form-item
                  :prop="'netLine.'+scope.$index+'.credit_type_id'"
                  :rules="{
                    required: true, message: $t('credit_notes.creditTypeErrorMsg'), trigger: 'blur'
                  }"
                >
                  <el-select
                    v-model="scope.row.credit_type_id"
                    filterable
                    reserve-keyword
                    :placeholder="$t('common.select.placeholder')"
                    size="small"
                    clearable>
                    <el-option
                      v-for="creditType in getCreditNoteTypesByCompanyId[getCurrentPortausCompany.id]"
                      :key="creditType.id"
                      :label="creditType.name"
                      :value="creditType.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="$t('credit_notes.amount')" v-if="$can('manage', 'CreditNotes')" align="center" class="align-vertical-top">
              <template slot-scope="scope" >
                <el-form-item size="medium">
                  <span class="m-0 mr-10">
                    <el-button v-if="!scope.row.editPrice" type="text" @click="editItemPrice({action:'show', index:scope.$index});">{{$n(scope.row.price, 'currency',currency.code)}} <i class="el-icon-edit"></i></el-button>
                    <el-input-number
                      :ref="'net_price_'+scope.$index"
                      v-show="scope.row.editPrice"
                      v-model="scope.row.price"
                      @keyup.enter.native="editItemPrice({action:'hide', index:scope.$index});"
                      @blur="editItemPrice({action:'hide', index:scope.$index});"
                      :min="0"
                      size="small"
                      :controls="false">
                    </el-input-number>
                  </span><br>
                  <TaxesPopover  :usedTaxes="scope.row.taxes" @applyTaxes="v=>setTaxes(v,scope.$index)"></TaxesPopover>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="creditNote.type=='PRODUCTS'">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('credit_notes.selectProduct')">
                  <el-autocomplete class="inline-input" :disabled="creditNote.fk_customer_id==null" value-key="item_name" v-model="selectedProduct" style="width:100%;" :fetch-suggestions="querySearch" :placeholder="$t('credit_notes.selectProductPlaceholder')" @select="addItemLineItem">
                    <template slot-scope="{ item }">
                      <ItemTemplate :product="item" :showQty="false" :volume="item.volume" :format="item.format"></ItemTemplate>
                    </template>
                  </el-autocomplete>
                </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="creditNote.lines" style="width: 100%"  v-loading="itemsLoading" size="mini" :row-style="tableRowStyleFct" :cell-style="tableCellStyleFct" :border="true">
            <span slot="empty">{{ $t('credit_notes.noProductSelected') }}</span>
            <el-table-column :resizable="true"
              :label="$t('credit_notes.product')">
              <template slot-scope="scope">
                <el-popover placement="top" trigger="hover" >
                  <span style="break-word:word-break;">{{scope.row.product.name}}</span><br>
                  <span v-if="scope.row.product.provider">
                    <span class="fs-14 secondary-text">{{customerName(scope.row.product.provider)}}</span><br>
                  </span>
                  <span v-if="scope.row.reference"><span class="fs-14 secondary-text">{{$t('invoices.lines.reference_code')}} {{scope.row.reference}}</span><br></span>
                  <span class="fs-14 secondary-text">SKU : {{scope.row.product.sku}}</span><br>
                  <UnitFormatVolumeLabel :unit="scope.row.product.unit" :uvc="scope.row.product.uvc" :format="scope.row.product.format" :volume="scope.row.product.volume"></UnitFormatVolumeLabel>


                  <div slot="reference" class="mt-10">
                    <i class="mdi" :class="{'mdi-barcode-scan' : scope.row.product.type==1, 'mdi-cards-variant' : scope.row.product.type==0}" style="font-size:18px;margin-right:5px;color: grey;"></i>
                    <span style="break-word:word-break;">{{scope.row.product.name}}</span><br>

                  </div>
                </el-popover>
                <el-input type="textarea" v-model="scope.row.description" autosize :placeholder="$t('common.addDescription')" class="mt-5" :autosize="{minRows:2, maxRows:2}"></el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-form-item
                  :prop="'lines.'+scope.$index+'.credit_type_id'"
                  :rules="{
                    required: true, message: $t('credit_notes.creditTypeErrorMsg'), trigger: 'blur'
                  }"
                >
                  <el-select
                    v-model="scope.row.credit_type_id"
                    filterable
                    reserve-keyword
                    :placeholder="$t('common.select.placeholder')"
                    size="small"
                    clearable>
                    <el-option
                      v-for="creditType in getCreditNoteTypesByCompanyId[getCurrentPortausCompany.id]"
                      :key="creditType.id"
                      :label="creditType.name"
                      :value="creditType.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="$t('credit_notes.amount')" v-if="$can('manage', 'CreditNotes')" align="center" class="align-vertical-top" width="180">
              <template slot-scope="scope" >
                <el-form-item >
                  <el-button v-if="!scope.row.editPrice" type="text" @click="editItemPrice({action:'show', index:scope.$index});">{{$n(scope.row.price, 'currency',currency.code)}} <i class="el-icon-edit"></i></el-button>
                  <el-input-number
                    :ref="'product_price_'+scope.$index"
                    @keyup.enter.native="editItemPrice({action:'hide', index:scope.$index});"
                    @blur="editItemPrice({action:'hide', index:scope.$index});"
                    v-if="scope.row.editPrice"
                    v-model="scope.row.price"
                    :min="0"
                    size="small"
                    :controls="false">
                  </el-input-number>
                  <el-button type="text" class="ml-5" @click="openCreditNotePriceCalculator(scope.row)"><i class="mdi mdi-calculator"></i></el-button><br>
                  <TaxesPopover  :usedTaxes="scope.row.taxes" @applyTaxes="v=>setTaxes(v,scope.$index)"></TaxesPopover>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="$t('credit_notes.quantity')"   align="center">
              <template slot-scope="scope">
                <el-form-item>
                   <el-input-number v-model="scope.row.qty" :min="0" size="small"></el-input-number>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="$t('credit_notes.subTotal')"  align="center">
              <template slot-scope="scope">
                <el-form-item>
                  <span>{{$n(totalLine(scope.row),'currency',currency.code)}}</span>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="30">
              <template slot-scope="scope">
                <el-form-item>
                  <el-link icon="el-icon-delete" :underline="false" @click="removeItemLine(scope.$index)"></el-link>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <table style="width:100%;margin-top:20px;" v-if="(creditNote.type=='PRODUCTS' && creditNote.lines.length>0) || (creditNote.type=='NET')">
            <tr>
              <td class="fs-14 secondary-text" style="text-align:right;">{{$t('credit_notes.subTotalField')}}</td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(creditNoteSubTotal,'currency',currency.code)}}</td>
            </tr>
            <tr v-for="(tax, index) in calculatedTaxes" :key="index">
              <td class="fs-14 secondary-text" style="text-align:right;">{{tax.name}} ({{tax.number}}) : </td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency',currency.code)}}</td>
            </tr>
            <tr>
              <td class="fs-14 secondary-text" style="text-align:right;">{{$t('credit_notes.totalField')}}</td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(creditNoteTotal,'currency',currency.code)}}</td>
            </tr>
        </table>
      <el-divider/>
      <el-row>
        <el-col>
          <el-form-item :label="$t('credit_notes.customerNotes')">
              <quill-editor v-model="creditNote.notes" style="border:1px solid #EBEEF5"
                ref="noteEditor"
                :options="editorOptions">
              </quill-editor>
              <p style="margin-top:0px;"><i><span style="font-size:0.8em;color:#909399">{{ $t('credit_notes.visibleOnCreditNote') }}</span></i></p>
            </el-form-item>
        </el-col>
      </el-row>
      </el-form>
    </el-col>
  </el-row>
  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="closeDialog">{{ $t('common.Cancel') }}</el-button>
    <el-button @click="saveCreditNote" type="primary">{{ $t('common.save') }}</el-button>
  </span>
  <CreditNotePriceCalculator :original_price="calculator.original_price" :type="calculator.type" :value="calculator.value" :amount="calculator.amount" @close="closeCreditNotePriceCalculator" :visible="creditNotrePriceCalculatorVisible" @apply="applyCalculation"></CreditNotePriceCalculator>
  </el-dialog>
</template>
<script>
import axios from "axios"
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import customerApi from '@/services/API/customer'
import creditNoteApi from '@/services/API/creditNote'
import productAPI from '@/services/API/product'
import inventoryApi from '@/services/API/inventory'
import ItemTemplate from '@/components/product/item-template'
import CreditNotePriceCalculator from '@/components/creditNote/credit-note-price-calculator'
import ContactPicker from '@/components/contact-picker'
import DefaultAddressCard from '@/components/address/Default-Address-Card'
import TaxesPopover from '@/components/taxes-popover'
import salesUtils from '@/utils/sales-utils.js'
import CustomerSelectItem from '@/components/customer-select-item'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'

export default {
  name: 'CreditNoteEditor',
	props: {
		visible : Boolean,
    creditNoteToEdit : {
        type : Object,
        default : null
    },
    customer : {
      type : Object,
      default : null,
    },
    invoice : {
      type : Object,
      default : null
    }
	},
  data() {
    return {
      creditNote : {
        type : 'PRODUCTS', //PRODUCTS OU NET,
        fk_customer_id : null,
        cr_number : null,
        reference : null,
        date : null,
        lines : [],
        netLine : [],
        notes : '',
        fk_currency_id : null,
        fk_billing_contact_id : null,
        billing_address : null,
        sales_rep_id: null,
      },
      customerTaxes : [],
      isCustomerTaxable: true,
      fixedType : false,
      contacts : [],
      taxes : [],
      rules : {
        date : [
  	  		 	{ required: true, message: 'Veuillez saisir une date.', trigger: 'blur' }
  	  		],
        fk_billing_contact_id : [
          	{ required: true, message: 'Veuillez saisir un contact de facturation', trigger: 'blur' }
        ]
      },
      creditNotrePriceCalculatorVisible : false,
      fullScreenLoading: false,
      itemsLoading : false,
      customersLoading : false,
      searchedCustomers : [],
      editorOptions: {
				theme: 'bubble',
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike']
					]
				}
			},
      calculator : {
        index : null,
        original_price : null,
        type : 'PERCENT',
        value : null,
        amount : null
      },
      currency : null,
      selectedProduct : null,
    };
  },components: {
    ItemTemplate,
    CreditNotePriceCalculator,
    ContactPicker,
    DefaultAddressCard,
    TaxesPopover,
    CustomerSelectItem,
    UnitFormatVolumeLabel
  },
	methods: {
    tableRowStyleFct({row, rowIndex}){
      return {
        "line-height":"10px"
      }
    },
    tableCellStyleFct({row, rowIndex}){
      return {
        "vertical-align":"top"
      }
    },
    editItemPrice({ action, index}){
      if(this.creditNote.type=='PRODUCTS'){
        this.creditNote.lines[index].editPrice = action=='show' ? true : false;
      }else{
          this.creditNote.netLine[index].editPrice = action=='show' ? true : false;
      }
      if(action==="show"){
        if(this.creditNote.type=='PRODUCTS'){
          this.$nextTick(() => this.$refs['product_price_'+index].focus())
        }else{
          this.$nextTick(() => this.$refs['net_price_'+index].focus())
        }

      }
    },
    setTaxes(taxes, index){
      if(this.creditNote.type=='PRODUCTS'){
        this.creditNote.lines[index].taxes = taxes;
      }else{
        this.creditNote.netLine[index].taxes = taxes;
      }
    },
    selectCreditType(value){
      if(value=='NET'){
        this.creditNote.netLine=[];
        this.creditNote.netLine.push({
          credit_type_id : null,
          qty :1,
          price : 0.00,
          taxable : false,
          taxes : [],
          editPrice : false,
        })
      }
    },
    setSelectedContact(contact){
      this.creditNote.fk_billing_contact_id=contact.id;
    },
    applyCalculation(calculatorObject){
      this.calculator.line.price = calculatorObject.amount;
      if(this.calculator.line.extra_info==null)this.calculator.line.extra_info = {};
      this.calculator.line.extra_info.calculator = _.cloneDeep(calculatorObject);
    },
    openCreditNotePriceCalculator(line){
      this.calculator.line = line;
      if(line.extra_info!=null && line.extra_info.calculator!=null){
        this.calculator.original_price = line.extra_info.calculator.original_price;
        this.calculator.type = line.extra_info.calculator.type;
        this.calculator.value = line.extra_info.calculator.value;
      }
      this.calculator.amount = line.price;
      this.creditNotrePriceCalculatorVisible = true;
    },
    closeCreditNotePriceCalculator(){
      this.calculator.original_price = null;
      this.calculator.type = "PERCENT";
      this.calculator.value = null;
      this.calculator.amount = null;
      this.creditNotrePriceCalculatorVisible = false
    },
    selectAddresses(addresses){
      if(this.invoice && this.invoice.billing_address){
        this.creditNote.billing_address = this.invoice.billing_address;
        this.creditNote.fk_billing_address_id = this.creditNote.billing_address.id;
      }else{
        if (_.size(addresses) === 1) {
          this.creditNote.billing_address = _.head(addresses);
          this.creditNote.fk_billing_address_id = this.creditNote.billing_address.id;

        } else {

          this.creditNote.billing_address = _.find(addresses, addr => _.get(addr, 'type.code') === 'BILLING');
          if (this.creditNote.billing_address == null) {
            this.creditNote.billing_address = _.find(addresses, addr => _.get(addr, 'type.code') === 'SHIPPING');
          }

          if (this.creditNote.billing_address == null) {
            this.creditNote.billing_address = _.find(addresses, addr => _.get(addr, 'type.code') === 'PRINCIPAL');
          }

        }

        
      }
    },
    selectCustomer(customerId, billingContact, billingAddress){
      if(customerId!=""){
        return customerApi.getCustomer(customerId)
          .then(customer=>{
            this.creditNote.fk_customer_id=customer.id;
            this.currency = customer.currency;
            // this.customerTaxes = customer.taxes;
            this.isCustomerTaxable = customer.taxable;
            this.creditNote.fk_currency_id = this.currency.id;
            this.creditNote.sales_rep_id = customer.rep_id;
            // this.taxes = [];
            // _.forEach(customer.taxes, t=>{
            //   this.taxes.push({id:t.id, gl_account_id : t.gl_account_id,label:t.name,taxNumber:t.number, rate:t.rate})
            // })
            this.contacts = customer.company ? customer.company.contacts : [customer.contact];
            if(billingContact){
              this.creditNote.fk_billing_contact_id=billingContact.id;
            }else{
              if(this.contacts.length==1){
                this.creditNote.fk_billing_contact_id=this.contacts[0].id;
              }else{
                _.forEach(this.contacts, c=>{
                  if(c.default_billing_ind)this.creditNote.fk_billing_contact_id=c.id;
                })
              }

            }

            if(billingAddress){
              this.creditNote.billing_address = billingAddress;
              this.creditNote.fk_billing_address_id = billingAddress.id;
            }else{
              this.selectAddresses(customer.company ? customer.company.addresses : customer.contact.addresses);
            }

          })
      }
    },
    addItemLineItem(item){
      this.itemsLoading=true;

      let productId = item.id;
      let inventoryId = item.inventory!=null?item.inventory.id:undefined;

      return inventoryApi.getProductPriceV2(inventoryId, productId,{qty:1,customerId:this.creditNote.fk_customer_id})
        .then(product=>{

            let taxes = [];
            _.forEach(product.taxes, t=>{
              if (this.isCustomerTaxable) {
                taxes.push(t);
              }
            })

            this.creditNote.lines.push({
              credit_type_id : null,
              fk_inventory_id : inventoryId,
              fk_item_id : null,
              fk_product_id : _.get(product, 'product.id'),
              price : _.get(_.head(product.prices), 'price'),
              product : product.product,
              qty : 1,
              taxable : item.taxable,
              editPrice :false,
              taxes,
              extra_info : {
                calculator : {
                  original_price : _.get(_.head(product.prices), 'price'),
                }
              }
            });
            // commit('ADD_ITEM_LINE_ITEM',{product, inventoryId, qty:1})
            this.itemsLoading=false;
        }).catch(err=>{
          console.log(err);

        })
    },
    querySearch(queryString, cb){
      productAPI.listProductsV2({paging:'no',searchTerms:queryString, limit:25 })
        .then(products=>{
          cb(products);
        })
    },
    removeItemLine(index){
      this.creditNote.lines.splice(index,1);
    },
    unitPrice(item){
      let price = 0.00;
      _.forEach(item.prices, p=>{
        price+=p.price;
      })
      return price;
    },
    fetchSearchedCustomers(query){
      this.customersLoading = true;
      return customerApi.fetchSearchedCustomers({searchTerms:query,paging:'no', active:true})
      .then(searchedCustomers => {
        this.searchedCustomers = searchedCustomers;
        this.customersLoading = false;
      });
    },
    closeDialog(){
      this.$emit('close');
      this.reset();
    },
    reset(){
      this.creditNote.fk_customer_id = null;
      this.creditNote.cr_number = null;
      this.creditNote.reference = null;
      this.creditNote.date = null;
      this.creditNote.lines = [];
      this.taxes = [];
      this.searchedCustomers = [];
      this.creditNote.fk_billing_contact_id = null;
      this.creditNote.type='PRODUCTS';
      this.creditNote.netLine=[];
    },
    open(){
      this.creditNote.date = new Date();
      this.fetchCreditNoteTypes();
      if(this.invoice!=null){
        this.fixedType=true; //Ceci est pour obliger la création d'une note de crédit PRODUCTS
        this.currency = this.invoice.currency;
        this.creditNote.fk_currency_id = this.currency.id;
        this.creditNote.invoice_id = this.invoice.id;
        _.forEach(this.invoice.taxes, t=>{
          this.taxes.push({id:t.id,name:t.name, rate : t.rate, number:t.number});
        })
        this.searchedCustomers.push(this.invoice.customer);
        this.selectCustomer(this.invoice.customer.id, this.invoice.billingContact, this.invoice.billingAddress);
        this.creditNote.fk_customer_id=this.invoice==null ? this.customer.id : this.invoice.customer.id;

        _.forEach(this.invoice.lines, l=>{
          let cr_line = {
            id : l.id,
            fk_product_id : l.product.id,
            fk_item_id : _.get(l, 'item.id'),
            fk_inventory_id : _.get(l, 'inventory.id'),
            product : l.product,
            qty : l.qty,
            credit_type_id : null,
            editPrice : false,
            taxes : l.productTaxes,
            extra_info : {
              calculator : {
                original_price : null
              }
            }

          }
          let taxes = [];
          _.forEach(l.taxes, t=>{

            let cTax = _.find(this.customerTaxes, ct=>{return ct.id==t.id})
            if(cTax!=null)taxes.push(cTax);
          })
          cr_line.price = 0.00;
          _.forEach(l.prices, p=>{
            if(p.takeAccountIntoCalculation==null || p.takeAccountIntoCalculation==true){
              cr_line.price+=p.price;
              cr_line.taxable  = p.taxable;

            }
          })
          cr_line.extra_info.calculator.original_price=cr_line.price;
          this.creditNote.lines.push(cr_line)
        })
      }else if(this.creditNoteToEdit!=null){
        this.creditNote.type = this.creditNoteToEdit.type;
        this.fixedType=true;
        this.creditNote.id = this.creditNoteToEdit.id;
        this.creditNote.cr_number = this.creditNoteToEdit.cr_number;
        this.creditNote.fk_customer_id = this.creditNoteToEdit.customer.id;
        this.creditNote.reference = this.creditNoteToEdit.reference;
        this.creditNote.date = this.creditNoteToEdit.date;
        this.creditNote.notes = this.creditNoteToEdit.notes;
        this.creditNote.fk_currency_id =this.creditNoteToEdit.currency.id;

        this.selectCustomer(this.creditNote.fk_customer_id, this.creditNote.billing_contact, this.creditNote.billing_address);

        this.currency =this.creditNoteToEdit.currency;
        _.forEach(this.creditNoteToEdit.taxes, t=>{
          this.taxes.push(t);
        })

        let lines = this.creditNote.type=='PRODUCTS'

        _.forEach(this.creditNoteToEdit.lines, l=>{
          let line = {
            description : l.description,
            fk_product_id : l.product!=null ? l.product.id : null,
            fk_item_id : l.item!=null ? l.item.id : null,
            fk_inventory_id : l.inventory!=null ? l.inventory.id : null,
            product : l.product!=null ? l.product : null,
            qty : l.qty,
            price : l.price,
            editPrice : false,
            taxes : l.taxes,
            extra_info : l.extra_info,
            credit_type_id : l.type!=null ? l.type.id :  null,
          }
          if(this.creditNote.type=='PRODUCTS'){
            this.creditNote.lines.push(line);
          }else{
            this.creditNote.netLine.push(line);
          }

        })
        this.searchedCustomers.push(this.creditNoteToEdit.customer)
      }else if(this.customer!=null){
        this.searchedCustomers.push(this.customer);
        this.selectCustomer(this.customer.id);
      }
    },
    totalLine(line){
      return Math.round((line.qty*line.price) *100)/100;
    },
    saveCreditNote(){
      this.$refs['creditNoteForm'].validate((valid)=>{
        if(valid){
          let creditNote = _.cloneDeep(this.creditNote);
          creditNote.taxes = this.calculatedTaxes;
          creditNote.sub_total = this.creditNoteSubTotal;
          creditNote.total = this.creditNoteTotal;

          if(creditNote.type=='NET'){
            creditNote.lines = creditNote.netLine;
          }
          creditNote.netLine = null;
          delete creditNote.netLine;

          _.forEach(creditNote.lines, l=>{
            l.sub_total = this.totalLine(l);
          })

          if(this.editionMode){
            return creditNoteApi.put(creditNote)
            .then(creditNoteUpdated=>{
              this.$emit('updated',creditNoteUpdated);
              this.$message.success("La note de crédit #" + creditNoteUpdated.cr_number+" a été modifiée avec succès");
              this.invalidateList();
              this.closeDialog();
            }).catch(err=>{
              console.log(err);
            })
          }else{
            return creditNoteApi.create(creditNote)
            .then(creditNoteCreated=>{
              this.$emit('created',creditNoteCreated);
              this.$message.success("La note de crédit #" + creditNoteCreated.cr_number+" a été créée avec succès");
              this.invalidateList();
              this.closeDialog();
            }).catch(err=>{
              console.log(err);
            })
          }

        }
      });

    },
    ...mapActions('controlData',['fetchCreditNoteTypes']),
    ...mapActions('creditNotes',['invalidateList'])
	},
	computed: {
    billingAddressName(){
      return this.$t("billing_address");
    },
    creditNoteTotal(){
      let total = this.creditNoteSubTotal;
      _.forEach(this.calculatedTaxes, t=>{
        total+=t.total;
      })
      return total;

    },
    calculatedTaxes(){
      let taxes = [];
      let lines = [];
      if(this.creditNote.type=='PRODUCTS'){
        lines = this.creditNote.lines;
      }else{
        lines = this.creditNote.netLine;
      }
      return salesUtils.calculateTaxesFromProductLines(lines);
    },
    creditNoteSubTotal(){
      let sub_total = 0.00;
      if(this.creditNote.type=='PRODUCTS'){
        _.forEach(this.creditNote.lines, l=>{
          sub_total+=this.totalLine(l);
        })
      }else{
        _.forEach(this.creditNote.netLine, l=>{
          sub_total+=this.totalLine(l);
        })
      }

      return Math.round(sub_total *100)/100;
    },
    title(){
      if(this.editionMode){
        return this.$i18n.t('credit_notes.editor.title_edit');
      }else{
        return this.$i18n.t('credit_notes.editor.title_new');
      }
    },
    editionMode(){
      return this.creditNoteToEdit!=null && this.creditNoteToEdit.id!=null;
    },
    ...mapGetters('customers',['customerName']),
    ...mapState('controlData',['credit_note_types']),
    ...mapGetters('controlData',['getCreditNoteTypesByCompanyId']),
    ...mapGetters(['getCurrentPortausCompany']),
	},
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}
.product{
  line-height:20px;

  .qty{
    float:right;
    position:relative
  }
  .empty {
    color:red;
  }
}

td{
  vertical-align: top;
}

.formContainer{
    margin-left:10%;
    width:80%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
